import { template as template_e7eccad45f0e4015b880ab90ab8c9da6 } from "@ember/template-compiler";
import { t } from 'ember-intl';
export default template_e7eccad45f0e4015b880ab90ab8c9da6(`
<div class="col d-flex h-100 justify-content-center align-items-center bi-no-data" ...attributes>
  {{t "status.0"}}
</div>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
